import socialLink from "./socialLink"
export default socialLink;
